<template>
  <div>
    <template v-if="target==='list'">
      <div class="MarketList">
        <h2>All Brands</h2>
        <el-table
            height="600"
            ref="filterTable"
            :data="brand_list"
            :row-style="tableRowClassName"
            class="table">
          <el-table-column
              prop="brand_id"
              label="bid"
              sortable
              align="center"
              width="220">
          </el-table-column>
          <el-table-column
              prop="brand_logo"
              label="Logo"
              align="center"
              width="180">
              <template slot-scope="scope">
                <img style="width: 50px;height: 50px;" :src="scope.row.brand_logo" alt="" srcset="">
              </template>
          </el-table-column>
          <el-table-column
              prop="brand_name_en"
              label="Name_en"
              width="200">
          </el-table-column>
          <el-table-column
              prop="brand_name_cn"
              label="Name_cn"
              width="200">
          </el-table-column>
          <!-- <el-table-column
              prop="brand_info_en"
              label="info_en"
              width="120">
          </el-table-column>
          <el-table-column
              prop="brand_info_cn"
              label="info_cn"
              width="120">
          </el-table-column> -->
          <el-table-column
              prop="clockin_reward"
              sortable
              label="clockin reward"
              align="center"
              width="160">
          </el-table-column>
          <el-table-column
              prop="sort"
              sortable
              label="sort"
              align="center"
              width="80">
          </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  style="width: 70px"
                  @click="onEdit(scope.row.brand_id)">Edit
              </el-button>
              <el-button
                  size="mini"
                  style="width: 70px"
                  type="danger"
                  @click="onDelete(scope.$index,scope.row.brand_id)">Delete
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template v-if="target==='edit'">
      <BrandCreate @return="onReturn" @back="onReturn" :bid="current_id"></BrandCreate>
    </template>
  </div>
</template>

<script>


  import {deleteBrand, getBrandList} from "@/utils/api";
  import BrandCreate from "@/components/Brand/BrandCreate/BrandCreate";

  export default {
    props: {},
    components: {
      BrandCreate
    },
    data: () => {
      return {
        brand_list: [],
        category_list: [],
        category_filter: [],
        target: 'list',
        current_id: '',
      }
    },
    beforeMount() {
      this.onRefresh()
    },
    methods: {
      onRefresh() {
        this.$showLoading('Loading');
        getBrandList().then(res => {
          this.brand_list = res.brand_list;
          this.$hideLoading()
        });
      },
      onReturn() {
        this.target = 'list';
        this.onRefresh()
      },
      onEdit(id) {
        this.target = 'edit';
        this.current_id = id
      },
      filterTag(value, row) {
        return row.category_id === value;
      },
      onDelete(index, id) {
        this.$confirm(`Are you sure you want to delete this brand?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteBrand(id).then(res => {
            if (res.errcode === 0) {
              this.brand_list.splice(index, 1);
              this.$message({
                type: 'success',
                message: `Brand Deleted!`
              });
            }
          });
        }).catch(() => {
        });
      },
      tableRowClassName({row}) {
        if (row.product_total_stock === 0) {
          return 'background: #ebebeb';
        }
        return '';
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "_BrandList.scss";
</style>